const constants = {
  OTP_LOGIN_PATH: '/buyer/otp_login',
  OTP_SIGN_PATH: '/users/sign_in',
  OTP_REFRESH_PATH: '/buyer/get_otp'
};

export default constants;
